var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "router-link",
                {
                  staticClass: "p-2",
                  attrs: { to: "/imprint", place: "terms" }
                },
                [_vm._v(_vm._s(_vm.$t("message.footer.imprint")))]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "p-2", attrs: { to: "/terms", place: "terms" } },
                [_vm._v(_vm._s(_vm.$t("message.footer.terms")))]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "p-2",
                  attrs: { to: "/policies", place: "privacyPolicies" }
                },
                [_vm._v(_vm._s(_vm.$t("message.footer.privacyPolicies")))]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "p-2", attrs: { to: "/info", place: "terms" } },
                [_vm._v(_vm._s(_vm.$t("message.footer.info")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-right" }, [
            _c("span", { staticClass: "p-2" }, [
              _vm._v(_vm._s(_vm.$t("message.footer.copyright")))
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b315264", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b315264","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TermsFooter.vue
// module id = USFi
// module chunks = 1